export enum ContentType {
  Audio = 1000,
  Image = 1001,
  Video = 1002,
  File = 1004,
  Icon = 1005
}
